import { Link, NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  FilePlus,
  LogOut,
  Users,
  Package,
  TrendingUp,
  Settings,
  Shield,
  User,
} from 'lucide-react'
import { ROUTES, APP } from '@/lib/constants'
import { authApi, setAccessToken } from '@/lib/api'
import { OrgSwitcher } from './org-switcher'

const NAV = [
  { to: ROUTES.DASHBOARD, label: 'Dashboard', icon: LayoutDashboard },
  { to: ROUTES.INVOICES, label: 'Facturas', icon: FilePlus },
  { to: ROUTES.CUSTOMERS, label: 'Clientes', icon: Users },
  { to: ROUTES.PRODUCTS, label: 'Productos', icon: Package },
  { to: ROUTES.REPORTS, label: 'Reportes', icon: TrendingUp },
  { to: ROUTES.HABILITACION, label: 'Habilitación DIAN', icon: Shield },
  { to: ROUTES.SETTINGS, label: 'Configuración', icon: Settings },
  { to: ROUTES.ACCOUNT, label: 'Mi cuenta', icon: User },
] as const

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-bg-app text-fg-primary">
      <aside className="hidden w-60 flex-none border-r border-border bg-bg-surface lg:block">
        <div className="flex h-16 items-center gap-2 border-b border-border px-5">
          <Link to={ROUTES.DASHBOARD} className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-500 font-mono text-xs font-bold text-white">
              Tx
            </div>
            <span className="text-sm font-semibold text-fg-primary">{APP.name}</span>
          </Link>
        </div>
        {/* J.6.4 — OrgSwitcher (solo aparece si memberships ≥ 2). */}
        <div className="px-3 pt-3">
          <OrgSwitcher />
        </div>
        <nav className="px-3 py-4">
          {NAV.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === ROUTES.DASHBOARD}
                className={({ isActive }) =>
                  `mb-1 flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-fg-secondary hover:bg-bg-elevated hover:text-fg-primary'
                  }`
                }
              >
                <Icon className="h-4 w-4 flex-none" />
                {item.label}
              </NavLink>
            )
          })}
          <button
            type="button"
            onClick={async () => {
              // Revoca sesión backend (limpia cookie refresh) y luego
              // limpia memoria local. Si backend falla, el catch en
              // authApi.logout swallow el error — el usuario sale igual.
              await authApi.logout()
              setAccessToken(null)
              window.location.href = ROUTES.LOGIN
            }}
            className="mt-4 flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium text-fg-secondary hover:bg-bg-elevated hover:text-fg-primary"
          >
            <LogOut className="h-4 w-4 flex-none" />
            Salir
          </button>
        </nav>
      </aside>
      <main className="flex-1 overflow-y-auto p-6 lg:p-10">{children}</main>
    </div>
  )
}
